import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FloatingBubbleModal.css';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import API_BASE_URL from '../config';



const FloatingBubbleModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bitacoraData, setBitacoraData] = useState([]);
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : {};
const estacionUsuario = decoded.estacion?.trim().toUpperCase() || 'SIN_ESTACION';


  const fetchBitacoraData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const filtrados = response.data.filter(
        (item) => item.estacion?.trim().toUpperCase() === estacionUsuario
      );
      setBitacoraData(filtrados);
      
    } catch (error) {
      console.error('Error al obtener la bitácora:', error);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchBitacoraData();
    }
  }, [isModalOpen]);

  return (
    <div>
      {/* Burbuja flotante */}
      <div
        className={`floating-bubble ${isModalOpen ? 'bubble-active' : ''}`}
        onClick={() => setIsModalOpen(!isModalOpen)}
      >
        📋
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal modal-animate-in">
            <div className="modal-header">
              <h2>Bitácora del Día</h2>
              <button
                className="close-button"
                onClick={() => setIsModalOpen(false)}
              >
                ✖
              </button>
            </div>
            <div className="modal-body">
              <table className="bitacora-table">
                <thead>
                  <tr>
                    <th>No. Fila</th>
                    <th>Siglas / #Colaborador</th>
                    <th>Nombre Completo</th>
                  </tr>
                </thead>
                <tbody>
                  {bitacoraData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.noFila}</td>
                      <td>{item.siglas} - {item.noColaborador}</td>
                      <td>{item.nombreCompleto}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingBubbleModal;
